var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHcIconAllergies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hc-icon-allergies_svg__Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f8ae15",
    d: "M111.53 130h-23a3.89 3.89 0 01-3.89-3.89v-10.66H73.9a3.89 3.89 0 01-3.9-3.89V88.49a3.9 3.9 0 013.89-3.9h10.66V73.9a3.89 3.89 0 013.89-3.9h23a3.89 3.89 0 013.89 3.89v10.68h10.77a3.9 3.9 0 013.89 3.9v23.12a3.9 3.9 0 01-3.89 3.9h-10.67v10.61a3.9 3.9 0 01-3.9 3.9zm-19.13-7.8h15.24v-10.61a3.89 3.89 0 013.89-3.89h10.67V92.36h-10.71a3.89 3.89 0 01-3.89-3.89V77.8H92.33v10.69a3.89 3.89 0 01-3.89 3.89H77.8v15.29h10.71a3.89 3.89 0 013.89 3.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#33a3dc",
    d: "M100 31.93A68.07 68.07 0 1131.93 100 68.14 68.14 0 01100 31.93m0-12.12A80.19 80.19 0 10180.19 100 80.19 80.19 0 00100 19.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#33a3dc",
    d: "M48.25 159.47A6.06 6.06 0 0144 149.13L147.21 45.89a6.06 6.06 0 018.57 8.56L52.54 157.69a6 6 0 01-4.29 1.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcIconAllergies);
export default ForwardRef;